<template>
  <div class="ma-4 px-4">
    <searchBar
      @add="(dialog = true), (editMode = false)"
      @updateSearch="(v) => (search = v)"
      headerText=""
    />

    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="headers"
            :search="search"
            :items="stream_schemes"
            :custom-filter="customFilter"
            fixed-header
            class="secondary row-height-50"
          >
            <template #[`item.program_id`]="{ item }">
              {{ getProgram(item) }}
            </template>
            <template #[`item.program_scheme_id`]="{ item }">
              {{ getProgramScheme(item) }}
            </template>
            <template #[`item.action`]="{ item }">
              <v-icon small class="mr-2" color="accent" @click="edit(item)">
                mdi-pencil
              </v-icon>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="800" persistent scrollable>
      <formDialog
        v-if="dialog"
        @closeDialog="dialog = false"
        @create="createStreamScheme"
        @update="updateStreamScheme"
        :stream_scheme="stream_scheme"
        :programs="programs"
        :program_schemes="program_schemes"
        :edit="editMode"
      />
    </v-dialog>
  </div>
</template>

<script>
import formDialog from "@/components/scheme/stream_scheme.vue";
import searchBar from "@/components/searchBar.vue";
import { streamSchemeHeaders } from "@/constants/headers";
export default {
  components: {
    formDialog,
    searchBar,
  },
  data() {
    return {
      headers: streamSchemeHeaders,
      dialog: false,
      editMode: false,
      deleteDialog: false,
      search: "",
      stream_schemes: [],
      program_schemes: [],
      programs: [],
      stream_scheme: {},
      stream_name: null,
    };
  },
  watch: {},
  computed: {},
  created() {
    this.stream_name = this.$route.query.name;
    this.program_id = this.$route.query.id;
    this.$store.commit("setBreadcrumbs", [
      { text: "Streams", to: { name: "Streams" } },
      {
        text: this.stream_name,
        to: {
          path: "/stream_scheme_lists",
          query: { id: this.program_id, name: this.stream_name },
        },
      },
      { text: "Stream Schemes" },
    ]);
    this.initialise();
  },
  methods: {
    async initialise() {
      const [stream_schemes, program_schemes, programs] = await Promise.all([
        this.$axios.get("stream_schemes"),
        this.$axios.get("program_schemes"),
        this.$axios.get("programs"),
      ]);
      const scheme_list = stream_schemes.data.data;
      this.stream_schemes = scheme_list.filter(
        (s) => s.program_id == this.program_id
      );
      this.program_schemes = program_schemes.data.data;
      this.programs = programs.data.data;
    },
    async createStreamScheme(data) {
      await this.$axios
        .post("stream_schemes", {
          stream_scheme: data,
        })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Stream Scheme created successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async updateStreamScheme(data) {
      await this.$axios
        .put("stream_schemes/" + data.id, {
          stream_scheme: data,
        })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Stream Scheme updated successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },

    edit(item) {
      this.stream_scheme = { ...item };
      this.editMode = true;
      this.dialog = true;
    },
    resetValues() {
      this.editMode = false;
      this.dialog = false;
      this.deleteDialog = false;
      this.stream_scheme = {};
    },

    showActiveStatus(value) {
      return value ? "Active" : "Inactive";
    },
    getProgram(item) {
      const program = this.programs.find((x) => x.id == item.program_id);
      return program?.degree?.short_name + " " + program?.specialization;
    },
    getProgramScheme(item) {
      const program_scheme = this.program_schemes.find(
        (p) => p.id === item.program_scheme_id
      );
      return program_scheme.name;
    },
    customFilter(value, search, item) {
      if (!search) return true;
      const program = this.getProgram(item);
      const program_scheme = this.getProgramScheme(item);
      return (
        JSON.stringify(item).toLowerCase().includes(search.toLowerCase()) ||
        program.toLowerCase().includes(search.toLowerCase()) ||
        program_scheme.toLowerCase().includes(search.toLowerCase())
      );
    },
  },
};
</script>

<style></style>
